import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Trophy, Building2, MapPin } from 'lucide-react';
const stats = [{
  icon: <Trophy className="w-6 h-6" data-id="element-162" />,
  value: 'Pro',
  label: 'Leagues'
}, {
  icon: <Building2 className="w-6 h-6" data-id="element-163" />,
  value: 'NCAA/CHL',
  label: 'Programs'
}, {
  icon: <Globe className="w-6 h-6" data-id="element-164" />,
  value: 'Global',
  label: 'Reach'
}, {
  icon: <MapPin className="w-6 h-6" data-id="element-165" />,
  value: 'NA & EU',
  label: 'Placements'
}];
export const NetworkSection = () => {
  return <section id="network" className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-166">
      {/* Abstract Map Background */}
      <div className="absolute inset-0 opacity-5 pointer-events-none flex items-center justify-center" data-id="element-167">
        <svg viewBox="0 0 1000 500" className="w-full h-full object-cover" data-id="element-168">
          <path d="M100,250 Q300,100 500,250 T900,250" fill="none" stroke="white" strokeWidth="2" strokeDasharray="10,10" data-id="element-169" />
          <circle cx="100" cy="250" r="8" fill="white" data-id="element-170" />
          <circle cx="500" cy="250" r="12" fill="white" data-id="element-171" />
          <circle cx="900" cy="250" r="8" fill="white" data-id="element-172" />
          <path d="M200,350 Q400,400 600,200 T800,150" fill="none" stroke="white" strokeWidth="1" strokeDasharray="5,5" data-id="element-173" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-174">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-175">
          <div data-id="element-176">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} className="text-4xl md:text-5xl font-bold text-white mb-6 uppercase tracking-tight" data-id="element-177">
              Our <span className="text-ice-500" data-id="element-178">Reach</span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            delay: 0.1
          }} className="text-lg text-slate-300 mb-8 leading-relaxed" data-id="element-179">
              Our value beyond our experience is our network. We maintain direct
              connections with junior, college, and pro coaches, GMs, and owners
              in North America and Overseas.
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            delay: 0.2
          }} className="text-lg text-slate-300 leading-relaxed" data-id="element-180">
              Whether it's finding the right junior program to develop your
              game, securing an NCAA commitment, or signing your first
              professional contract in Europe, our relationships open doors that
              others can't.
            </motion.p>
          </div>

          <div className="grid grid-cols-2 gap-4 sm:gap-6" data-id="element-181">
            {stats.map((stat, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-navy-800 border border-navy-700 p-6 rounded-sm flex flex-col items-center text-center hover:border-gold-500/50 transition-colors" data-id="element-182">
                <div className="text-gold-500 mb-4" data-id="element-183">{stat.icon}</div>
                <div className="text-2xl sm:text-3xl font-black text-white mb-1" data-id="element-184">
                  {stat.value}
                </div>
                <div className="text-sm font-semibold text-slate-400 uppercase tracking-wider" data-id="element-185">
                  {stat.label}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};